import CityPageTemplate from "../city-template/CityPageTemplate";
import { hamptonConfig } from "./data";

export default function HamptonPage() {
  return <CityPageTemplate config={hamptonConfig} />;
}